export function correctLongitudeCoor(longitude: number) {
  if (longitude > 180) {
    longitude = longitude - 360;
  }
  if (longitude < -180) {
    longitude = longitude + 360;
  }
  return longitude;
}
